import Section from './ui/Section';
import Reveal from './ui/Reveal';
import lightbulb from '../assets/img/lightbulb.svg';
import bezier from '../assets/img/bezier.svg';
import gear from '../assets/img/gear.svg';
import target from '../assets/img/target.svg';

const STEPS = [
  {
    n: '01',
    icon: lightbulb,
    title: 'Discovery',
    text: 'We dig into your goals, constraints and users to define what actually needs building — before a single line of code.',
  },
  {
    n: '02',
    icon: bezier,
    title: 'Architecture',
    text: 'We design the system: stack, data flow and interfaces, built to scale and to last.',
  },
  {
    n: '03',
    icon: gear,
    title: 'Build',
    text: 'Senior engineers ship in tight, transparent iterations — with quality and performance baked in.',
  },
  {
    n: '04',
    icon: target,
    title: 'Scale & support',
    text: 'We launch, monitor and keep evolving — hosting, optimization and an ongoing partnership.',
  },
];

export default function Process() {
  return (
    <Section id="process" heading="How we work" index="02">
      <Reveal>
        <p className="max-w-3xl font-avenir text-brand-light-gray md:text-lg lg:text-xl">
          A clear, senior-led process — from the first conversation to a system that keeps delivering.
        </p>
      </Reveal>

      {/* Borderless timeline: steps linked by a thin line with yellow node dots (horizontal
          on desktop, vertical on mobile). No boxes — cohesive with Services/Skills, and the
          line communicates the sequence. */}
      <div className="relative mt-16">
        {/* mobile: vertical spine */}
        <div aria-hidden="true" className="absolute bottom-3 left-[6px] top-2 w-px bg-white/10 md:hidden" />
        {/* desktop: horizontal spine */}
        <div
          aria-hidden="true"
          className="absolute inset-x-0 top-[6px] hidden h-px md:block"
          style={{
            background:
              'linear-gradient(90deg, transparent, rgba(255,255,255,0.14) 6%, rgba(255,255,255,0.14) 94%, transparent)',
          }}
        />

        <div className="grid grid-cols-1 gap-y-10 md:grid-cols-4 md:gap-x-10">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={(i % 4) * 0.08} className="relative pl-9 md:pl-0 md:pt-12">
              <span className="absolute left-0 top-[1px] h-3 w-3 rounded-full border-[1.5px] border-brand-yellow bg-ink-850" />
              <div className="font-gotham text-3xl font-bold tabular-nums text-white/15">{s.n}</div>
              <img
                src={s.icon}
                alt=""
                aria-hidden="true"
                loading="lazy"
                decoding="async"
                className="mt-4 h-8 w-8 object-contain opacity-80 brightness-0 invert"
              />
              <h3 className="mt-4 font-gotham text-xl font-bold text-white lg:text-2xl">{s.title}</h3>
              <p className="mt-2 font-avenir text-brand-light-gray">{s.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
